import { useTranslation } from 'react-i18next';

import { SectionHeader } from './SectionHeader';
import { SyncWorkerSettingsShowcase } from './patterns/SyncWorkerSettingsShowcase';

export function PatternsSection() {
  const { t } = useTranslation();

  return (
    <section id="patterns" className="space-y-8">
      <SectionHeader
        title={t('uiLibrary.patterns.title')}
        description={t('uiLibrary.patterns.description')}
      />
      <SyncWorkerSettingsShowcase />
    </section>
  );
}
